import MuiIcon from 'components/Icons/MuiIcon';
import React, {useEffect, useState} from 'react';

function ButtonSorting({order, isOrdered}) {
  const [icon, setIcon] = useState('unfold_more');

  useEffect(() => {
    let icon = 'unfold_more';
    switch (order) {
      case 'ASC':
        icon = 'arrow_upward';
        break;
      case 'DESC':
        icon = 'arrow_downward';
        break;
      default:
        icon = 'unfold_more';
    }

    setIcon(icon);
  }, [order]);

  return (
    <MuiIcon
      name={isOrdered ? icon : 'unfold_more'}
      className="cursor-pointer mx-2"
    />
  );
}

export default ButtonSorting;
